export default __webpack_public_path__ + "static/media/Салбар уулзалт гүйцэтгэл, үр дүнгийн үнэлгээ.fc2c89f9.pdf";